import { useEffect } from 'react';
import Base from 'layouts/Base';
import { useDisplayedNews } from 'providers/generalContext';
import { useLocation } from 'react-router-dom';
import EducationTemplate from '../templates/EducationTemplate';

function Education() {
    const { location } = useLocation();
    const { setDisplayedNews } = useDisplayedNews();

    useEffect(() => {
        setDisplayedNews({});
        // eslint-disable-next-line
    }, [location]);
    return (
        <Base title="Educação" link="/educacao">
            <EducationTemplate />
        </Base>
    );
}

export default Education;
